import api from '@/services';
import utils from '@/services/utils';

const state = {
  user: {},
  accessToken: null,
};

const mutations = {
  SIGN_IN_SUCCESS(state, auth) {
    state.user = auth.user;
    state.accessToken = auth.accessToken;
  },

  SIGN_OUT_SUCCESS(state) {
    state.user = {};
    state.accessToken = null;
  },
};

const actions = {
  async signIn({ commit }, data) {
    const response = await utils.request(api.auth.signIn(data));
    if (response && response.status === 200) {
      commit('SIGN_IN_SUCCESS', response.data);
      localStorage.setObject('auth', response.data);
    }
    return response;
  },
  async signOut({ commit }) {
    return new Promise((resolve, reject) => {
      try {
        commit('SIGN_OUT_SUCCESS');
        resolve(localStorage.setObject('auth', null));
      } catch (error) {
        reject(error.message);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js